
import api from 'api';
import _ from 'lodash';

import types from '../actions';

function create() {
  return {
    type: types.GROUPS_CREATE,
    payload: {},
  };
};

function createSuccessful() {
  return {
    type: types.GROUPS_CREATE_SUCCESSFUL,
    payload: {},
  };
};

function receiveGroupMetadata(collection) {
  return {
    type: types.GROUPS_RECEIVE,
    payload: {
      collection,
      isDataFetched: true,
    },
  }
}

function getMetadata(subdomain) {
  return (dispatch) => {
    return api.groupApi.getMetadata(subdomain).then(group => {
      group.theme.accent_rgba = group.theme.accent_rgba || { r: 160, g: 0, b: 41, a: 1 };
      group.theme.base_rgba = group.theme.base_rgba || { r: 216, g: 27, b: 81, a: 1 };
      group.theme.highlight_rgba = group.theme.highlight_rgba || { r: 255, g: 92, b: 125, a: 1 };

      dispatch(receiveGroupMetadata([group]));
      return group;
    }).catch(res => {
      dispatch(receiveGroupMetadata([]));
      return Promise.reject(res);
    });
  };
}

function updated(group) {
  return {
    type: types.GROUP_UPDATED,
    payload: {
      group,
    },
  }
}

function request(groupId) {
  return (dispatch) => {
    return api.groupApi.get(groupId)
      .then(group => dispatch(updated(group)));
  }
}

function receiveAdmins(admins) {
  return {
    type: types.GROUP_ADMINS_RECEIVED,
    payload: _.assign({}, admins),
  }
}

function requestAdmins(groupId) {
  return (dispatch) => {
    api.groupApi.getAllAdmins(groupId).then(admins => {
      dispatch(receiveAdmins(admins));
    })
  };
}

function receiveGroupStats(groupId, stats) {
  return {
    type: types.GROUP_STATS_RECEIVED,
    groupId,
    payload: _.assign({}, { stats }),
  }
}

function getStats(groupId) {
  return (dispatch) => {
    api.groupApi.getStats(groupId).then(stats => {
      dispatch(receiveGroupStats(groupId, stats));
    })
  };
}


const actions = {
  create,
  createSuccessful,
  getMetadata,
  updated,
  requestAdmins,
  request,
  getStats,
};

export default actions;